const zh = {
    app: {
        lang: '语言',
        edit_pwd: '修改密码',
        logout: '退出登录',
        manage_title: '管理系统',
        save: '保存',
        back: '返回',
        operation: '操作',
        status: '状态',
        on: '启用',
        off: '禁用',
        search: '搜索',
        order_no: '订单号',
        start_time: '开始时间',
        end_time: '结束时间',
        id: 'ID',
        name: '名称',
        username: '用户名',
        password: '密码',
        sort: '排序',
        icon: '图标',
        route: '路由',
        desc: '描述',
        role: '角色',
        center: '处理中心',
        start: '开始',
        complete: '完成',
        edit: '编辑',
        del_tip: '确定要删除此数据吗?',
        del_m_tip: '确定要删除这些数据吗?',
        tip: '提示',
        ok: '确定',
        cancel: '取消',
        list: '列表',
        need_sel_one: '至少选择一项',
    },
    login: {
        title: '管理员登录',
        username: '用户名',
        pwd: '密码',
        verify: '验证码',
        remember: '记住登录',
        login: '登录',
    },
    admin: {
        edit_pwd: '修改密码',
        old_pwd: '旧密码',
        new_pwd: '新密码',
        confirm_pwd: '确认新密码',
        re_pwd: '两次密码输入不一致！',
    },
    order: {
        list: '订单列表',
        ongoing: '进行中',
    },
    user: {
        nickname: '称呼',
        manage: '用户管理',
        edit: '用户编辑'
    },
    flow: {
        user: '操作员',
        cart_no: '推车号',
        box_num: '装箱数',
        submit_user: '提交人',
    },
    ftype: {
        1: '备货',
        2: '检测',
        3: '封装',
        4: '闭装',
    },
    wtype: {
        0: '待备货',
        1: '待检测',
        2: '待封装',
        3: '待闭封',
        4: '已完成',
    },
    ontype: {
        0: '备货中...',
        1: '检测中...',
        2: '封装中...',
        3: '闭封中...',
    },
    menu: {
        'order': '订单管理',
        'stock': '备货管理',
        'check': '检测管理',
        'pack': '封装管理',
        'close': '闭装管理',
    },
}

export default zh;